import { NgModule } from '@angular/core';
import { BaseModule } from '@shared';
import { SharedDataModule } from '@shared-data';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { CategoryComponent } from './components/category/category.component';
import { TasksComponent } from './components/tasks/tasks.component';
import { RestaurantComponent } from './components/restaurant/restaurant.component';
import { DatePipe } from '@angular/common';
import { ItemComponent } from './components/item/item.component';

@NgModule({
  declarations: [
    CategoryComponent,
    AdminComponent,
    TasksComponent,
    RestaurantComponent,
    ItemComponent,
  ],
  imports: [
    BaseModule,
    AdminRoutingModule,
    SharedDataModule,
    BaseModule,
  ],
  exports: [],
  providers: [DatePipe],
})
export class AdminModule {}
